export default __webpack_public_path__ + "static/media/gallery-wip-greeblies_00.906e68a5.jpg";